import React from 'react';
import { Dialog, DialogContent } from '~/shared/components/Dialog';
import { useTranslation } from '~/shared/utils/translation';
import styles from './DeliveryEstimateDialog.module.scss';
import { Button } from '~/shared/components/Button';
import { Text } from '~/shared/components/Text';

type DeliveryEstimateDialogProps = {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    onCancel: () => void;
    deliveryEstimate: string; // Format: "x-y" (e.g., "3-5")
};

export const DeliveryEstimateDialog = ({
    isOpen,
    onOpenChange,
    onConfirm,
    onCancel,
    deliveryEstimate,
}: DeliveryEstimateDialogProps) => {
    const { translate } = useTranslation();

    const handleConfirm = () => {
        onConfirm();
        onOpenChange(false);
    };

    const handleCancel = () => {
        onCancel();
        onOpenChange(false);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent>
                <div className={styles.dialogContainer}>
                    <div className={styles.contentWrapper}>
                        <div className={styles.warningIcon} />
                        <Text>
                            {translate('checkout.delivery.instore.estimateWarningMessage', {
                                estimate: deliveryEstimate,
                            })}
                        </Text>
                    </div>
                    <div className={styles.buttonsContainer}>
                        <Button
                            className={styles.dialogButton}
                            variant="campaign"
                            onClick={handleConfirm}
                            tabIndex={0}
                        >
                            {translate('common.yes')}
                        </Button>
                        <Button
                            className={styles.dialogButton}
                            variant="brand"
                            onClick={handleCancel}
                            tabIndex={0}
                        >
                            {translate('common.no')}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
